import { writable } from 'svelte/store'

export const navbarSearchQuery = writable<string>('')
